import React from "react";
import { Link } from "react-router-dom";
import { listedTopics } from "../content/learn";
import { useSeo } from "../lib/useSeo";
import { PublicPageHeader, PublicPageFooter } from "./PublicPageChrome";

// LearnHub — the /learn index. Cards one per topic, in the order defined by
// `listedTopics` (sheriff first, on purpose — see the comment there).
//
// Design shape mirrors GlossaryHub (Glossary.tsx:185-216) so the two "hub of
// explainers" surfaces read consistently.

const LearnHub: React.FC = () => {
  useSeo({
    title: "Learn — NC foreclosure and property-sale rules explained | Parcely",
    description:
      "Reference pages for every property class Parcely tracks: tax foreclosures, mortgage foreclosures, sheriff execution sales, delinquent-tax lists, and more.",
  });

  return (
    <>
      <PublicPageHeader />
      <div className="legal-page" id="main" tabIndex={-1}>
        <div className="legal-content">
          <h1>Learn</h1>
          <p className="legal-updated">
            Reference pages, one per property class we track. Every page is
            grounded in NC statute and cited where possible.
          </p>
          <p>
            North Carolina publishes several different kinds of property sale
            through several different court and county processes, and they
            aren't interchangeable. Bidding at one thinking it's another can
            cost real money. These pages exist so a buyer can understand what
            they're about to bid on <em>before</em> the auction, not after.
          </p>

          <ul style={{ listStyle: "none", padding: 0, margin: "24px 0 0" }}>
            {listedTopics.map((topic) => (
              <li key={topic.slug} style={{ margin: "0 0 20px" }}>
                <Link
                  to={`/learn/${topic.slug}`}
                  style={{
                    display: "block",
                    padding: "16px 18px",
                    borderRadius: 8,
                    background: "rgba(148, 163, 184, 0.08)",
                    textDecoration: "none",
                    color: "inherit",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      justifyContent: "space-between",
                      gap: 12,
                      flexWrap: "wrap",
                    }}
                  >
                    <strong style={{ fontSize: 17 }}>{topic.label}</strong>
                    {topic.draft && (
                      <span
                        style={{
                          fontSize: 11,
                          textTransform: "uppercase",
                          letterSpacing: 0.5,
                          color: "#b45309",
                          background: "rgba(180, 83, 9, 0.12)",
                          padding: "2px 8px",
                          borderRadius: 999,
                        }}
                      >
                        Draft
                      </span>
                    )}
                  </div>
                  <p
                    style={{
                      margin: "6px 0 0",
                      fontSize: 14,
                      color: "var(--text-secondary, #475569)",
                    }}
                  >
                    {topic.summary}
                  </p>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <PublicPageFooter />
    </>
  );
};

export default LearnHub;
